import { Button, Link, ListItem, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Trans } from 'react-i18next';

import { getAssetPath } from '@/constants/configs';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';
import { selectConfigsState } from '@/redux/configs/selectors';

import {
  ButtonWrapper,
  Container,
  ContentWrapper,
  Logo,
  StyledList,
} from './MinorAgeValidationFailedPage.styled';

export function MinorAgeValidationFailedPage() {
  const { t, language } = useTranslate();
  const dispatch = useAppDispatch();
  const { links } = useAppSelector(selectConfigsState);
  const onBackToSignIn = () => dispatch(signOut());

  const transComponents = {
    savingsPlus: <LinkComponent href={links?.savingsPlusURL} />,
    pica: <LinkComponent href={links?.picaURL} />,
    personalChequing: <LinkComponent href={links?.personalChequingURL} />,
    timeSaver: <LinkComponent href={links?.timeSaverURL} />,
    eFree: <LinkComponent href={links?.eFreeURL} />,
    eFreeUsd: <LinkComponent href={links?.eFreeUsdURL} />,
    usdSavings: <LinkComponent href={links?.usdSavingsURL} />,
    eurSavings: <LinkComponent href={links?.eurSavingsURL} />,
    listItem: <ListItem />,
  };

  return (
    <Container>
      <Logo src={getAssetPath('/logo-with-text.svg')} alt="Republic Bank" />

      <ContentWrapper>
        <Typography variant="bodyB2Regular" mb={3}>
          {t('createNewAccount.minorAgeValidationFailed.body')}
        </Typography>

        <Typography variant="bodyB2Regular">
          <StyledList>
            <Trans
              i18nKey="createNewAccount.minorAgeValidationFailed.body2"
              lang={language}
              components={transComponents}
            />
          </StyledList>
        </Typography>
        <ButtonWrapper>
          <Button fullWidth variant="text" onClick={onBackToSignIn}>
            {t('createNewAccount.minorAgeValidationFailed.button.backToLogin')}
          </Button>
        </ButtonWrapper>
      </ContentWrapper>
    </Container>
  );
}

const LinkComponent = ({
  children,
  href,
}: PropsWithChildren & { href?: string }) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      textDecoration: 'none',
      fontWeight: 'medium',
    }}
  >
    {children}
  </Link>
);

export default MinorAgeValidationFailedPage;
